package net.gorillagroove.util

internal actual class Lock {
    actual fun lock() { }
    actual fun unlock() { }
}
